import { normalSanatizerBRL } from "src/utils/functions";

const TARGET_AMOUNT = 1000000;

export function PrimeiroMilhaoTable({
  results,
}: {
  results: PrimeiroMilhaoResultsType;
}) {
  return (
    <div className="max-h-[400px] overflow-y-auto m-auto overflow-x-auto">
      <table className="bg-white rounded w-full max-h-[400px] overflow-y-auto">
        <thead className="bg-gray-200 sticky top-0">
          <tr>
            <th className="px-4 py-2 text-center truncate">Ano</th>
            <th className="px-4 py-2 text-center truncate">Investimento Anual</th>
            <th className="px-4 py-2 text-center truncate">Juros do Ano</th>
            <th className="px-4 py-2 text-center truncate">Total Investido</th>
            <th className="px-4 py-2 text-center truncate">Total Juros</th>
            <th className="px-4 py-2 text-center truncate">Total Acumulado</th>
          </tr>
        </thead>

        <tbody className="max-h-[400px] overflow-y-auto">
          {results.yearlyResults.map((yearData, index) => (
            <tr 
              className={`border-b ${
                yearData.totalAccumulated >= TARGET_AMOUNT
                  ? "bg-green-50"
                  : ""
              }`} 
              key={index}
            >
              <td className="px-4 py-2 text-center">
                {yearData.year}
                {yearData.totalAccumulated >= TARGET_AMOUNT && (
                  <div className="text-xs text-green-600 font-semibold">
                    META!
                  </div>
                )}
              </td>
              <td className="px-4 py-2 text-center">
                <span className="text-sm mr-1">R$</span>
                {normalSanatizerBRL(yearData.yearlyInvestment)}
              </td>
              <td className="px-4 py-2 text-center">
                <span className="text-sm mr-1">R$</span>
                {normalSanatizerBRL(yearData.yearlyInterest)}
              </td>
              <td className="px-4 py-2 text-center">
                <span className="text-sm mr-1">R$</span>
                {normalSanatizerBRL(yearData.totalInvested)}
              </td>
              <td className="px-4 py-2 text-center">
                <span className="text-sm mr-1">R$</span>
                {normalSanatizerBRL(yearData.totalInterest)}
              </td>
              <td className="px-4 py-2 text-center">
                <span className="text-sm mr-1">R$</span>
                <span
                  className={
                    yearData.totalAccumulated >= TARGET_AMOUNT
                      ? "font-bold text-green-600"
                      : ""
                  }
                >
                  {normalSanatizerBRL(yearData.totalAccumulated)}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}